export const component = {
    module:'labs',
    moduleShow:'Lab'
}